////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const logUsers = {
	[ActionsTypes.POST_LOG_USERS]: (state) =>
		update(state, {
			logUsers: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.POST_LOG_USERS_SUCCESS]: (state, payload) => {
		let itemsConf = cloneDeep(payload.data.headerContent.contentPagined.content)
		itemsConf.forEach((elem) => (elem['selected'] = false))
		let paginedData = payload.data.headerContent.contentPagined
		let payloadFiltersCp = cloneDeep(payload.data.headerParam.filters)
		return update(state, {
			logUsers: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: itemsConf,
				},
				paging: {
					$set: paginedData,
				},
				header: {
					$set: payloadFiltersCp,
				},
			},
		})
	},
	[ActionsTypes.POST_LOG_USERS_FAILURE]: (state, _payload) =>
		update(state, {
			logUsers: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: ' payload.error,',
				},
			},
		}),
	[ActionsTypes.RESET_LOG_USERS]: (state) =>
		update(state, {
			logUsers: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: [],
				},
				header: {
					$set: {},
				},
				paging: {
					$set: {},
				},
			},
		}),
}

export default logUsers
